import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ValidatorService} from 'angular-iban';
import {IbanCheckExternalRequest} from 'src/model/requests/IbanCheckExternalRequest';
import {CheckibanApiService} from '../../../api/checkiban-api.service';
import {Message, MessagesService} from "../../services/messages.service";
import {ResultCardComponent} from "./result-card/result-card.component";

const CF_PIVA_PATTERN = /^(?:(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]|\d{11})$/i
const CF_REGEX = /^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/
const PIVA_REGEX = /^\d{11}$/

@Component({
  selector: 'app-check-iban',
  templateUrl: './check-iban.component.html',
  styleUrls: ['./check-iban.component.scss'],
  providers: [ResultCardComponent]
})
export class CheckIbanComponent {
  constructor(private checkIbanService: CheckibanApiService, private messagesService: MessagesService) {
  }

  public checkForm = new FormGroup({
    iban: new FormControl('', [Validators.required, ValidatorService.validateIban]),
    cfvat: new FormControl('', [Validators.required, Validators.pattern(CF_PIVA_PATTERN)])
  });

  iban: string | undefined;
  fiscalCode: string | undefined;
  vatCode: string | undefined;
  taxCode: string | undefined;
  formData: IbanCheckExternalRequest = {
    iban: '',
    fiscalCode: '',
    vatCode: '',
    taxCode: '',
    forceInterrogation: false,
    username: '',
    businessUnit: ''
  };
  ibanCheckResult: any | undefined = undefined

  async serviceCheck() {
    this.ibanCheckResult = undefined;
    const erroriValidazione: Message[] = [];

    if (this.checkForm.controls['iban'].errors?.['required']) {
      erroriValidazione.push({text: "IBAN obbligatorio", type: "error"})
    } else if (this.checkForm.controls['iban'].errors?.['iban']) {
      erroriValidazione.push({text: "IBAN non valido", type: "error"})
    }

    if (this.checkForm.controls['cfvat'].errors?.['required']) {
      erroriValidazione.push({text: "Codice Fiscale o Partita IVA obbligatorio", type: "error"})
    } else if (this.checkForm.controls['cfvat'].errors?.['pattern']) {
      erroriValidazione.push({text: "Codice Fiscale o Partita IVA non valido", type: "error"})
    }

    if (erroriValidazione.length > 0) {
      this.messagesService.addMessages(erroriValidazione)
      return;
    }

    this.formData = this.detectVatOrCf(this.checkForm.value);
    await this.checkIbanService.function1PostApiiban(this.formData)
    .then(response => {
      this.iban = this.formData.iban;
      this.fiscalCode = this.formData.fiscalCode;
      this.vatCode = this.formData.vatCode;
      this.taxCode = this.formData.taxCode;
      if (response != undefined && response.status) {
        this.ibanCheckResult = {...response, iban: this.iban, fiscalCode: this.fiscalCode, vatCode: this.vatCode};
      }
    })
    .catch(() => {
      this.messagesService.addMessage({text: "Errore inatteso del servizio", type: "error"})
    });
  }

  detectVatOrCf(orig: any): IbanCheckExternalRequest {
    const ret: IbanCheckExternalRequest = {
      iban: orig.iban.replaceAll(" ", ""),
      username: '',
      businessUnit: '',
    };

    if (orig.cfvat != undefined && CF_REGEX.test(orig.cfvat.toUpperCase())) {
      ret.vatCode = undefined;
      ret.fiscalCode = orig.cfvat.toUpperCase();
    }

    if (orig.cfvat != undefined && PIVA_REGEX.test(orig.cfvat.toUpperCase())) {
      ret.vatCode = orig.cfvat.toUpperCase();
      ret.fiscalCode = undefined;
    }

    return ret
  }

  resetForm() {
    this.checkForm.reset();
    this.ibanCheckResult = undefined;
  }
}
